
import Gradient from './../../zviz2/zviz/components/svg/lineargradient';
import StopBlueprint from './../../zviz2/zviz/components/svg/stop';
import config from './../../config';
import {extend} from './../../zviz2/zviz/functions';

let stop1 = extend({
    properties: {
        attributes: { 'offset': '0' },
        style: { stopColor: '#ffffff', stopOpacity: 1 }
    }
}, StopBlueprint);

let stop2 = extend({
    properties: {
        attributes: { 'offset': '0.95' },   // using 0.95 here to prevent a bug in webkit from hapening
        style: { stopColor: '#ffffff', stopOpacity: 0 }
    }
}, StopBlueprint);

export let gradient1 = extend({
    properties:{
        attributes: {
            'id': 'mapFade1',
            'x1': 0, 
            'y1': 0, 
            'x2': 0, 
            'y2': config.display.fadeWidth  
        }
    },
    children: [stop1, stop2]
}, Gradient);

export let gradient2 = (parent) => (extend({
    properties:{
        attributes: {
            'id': 'mapFade2',
            'x1': parent.data.w, 
            'y1': 0, 
            'x2': (parent.data.w-config.display.fadeWidth), 
            'y2': 0  
        }
    },
    children: [stop1, stop2]
}, Gradient) );

export let gradient3 = (parent) => (extend({
    properties:{
        attributes: {
            'id': 'mapFade3',
            'x1': 0, 
            'y1': parent.data.h,
            'x2': 0,
            'y2': (parent.data.h-config.display.fadeWidth)  
        }
    },
    children: [stop1, stop2]
}, Gradient) );

export let gradient4 = extend({
    properties:{
        attributes: {
            'id': 'mapFade4',
            'x1': 0, 
            'y1': 0, 
            'x2': config.display.fadeWidth, 
            'y2': 0  
        }
    },
    children: [stop1, stop2]
}, Gradient);